import React from 'react';
import { Form, Localization, Theme } from 'connex-cds';
import cn from 'classnames';
import { useCompanySetup } from '../../../../../MasterDataProvider';
import { Styled } from './style';

const testId = 'activityGrid-water';

export const WaterAdd = () => {
  const translateMessage = Localization.useTranslateMessage();
  const { themeName: theme } = Theme.useThemeContext();
  const { values } = Form.useFormContext();
  const companySetup = useCompanySetup();

  const waterEvents = React.useMemo(() => {
    return values.waterAddedEvents.filter(
      waterAddedEvent =>
        !waterAddedEvent.driverDidNotAdd || (companySetup?.data?.isWaterMandatory && waterAddedEvent.driverDidNotAdd)
    );
  }, [values.waterAddedEvents]);

  if (!values?.waterAddedEvents?.length) {
    return null;
  }

  return (
    <Styled className={cn('water-add-mobile')} theme={theme}>
      {waterEvents?.map?.((waterEvent, index) => {
        const key = `SETUP_REASON-CODE_${waterEvent?.reason?.id}`.replace(/\s/gi, '_').toUpperCase();
        const translation = translateMessage(key);

        const materialOnTruck = waterEvent.concreteOnTruck;
        const reasonText = translation && translation !== key ? translation : waterEvent?.reason?.description;

        return (
          <table>
            <tr className={cn('header-row')}>
              <td className={cn('header-cell')} colSpan="2">
                <Localization.Translate stringId="waterAdded" data-testid="water-added-label" />
              </td>
            </tr>
            <tr>
              <td className={cn('header-cell')}>
                <Localization.Translate stringId="quantity" data-testid="quantity-label" />
              </td>
              <td data-testid={`${testId}-row-${index}-activity-value`}>
                <Localization.Uom uom={waterEvent.quantity} />
              </td>
            </tr>
            {materialOnTruck && (
              <tr>
                <td className={cn('header-cell')}>
                  <Localization.Translate stringId="materialOnTruck" data-testid="water-added-label" />
                </td>
                <td className={cn('data-cell')} data-testid={`${testId}-row-${index}-concrete-value`}>
                  <Localization.Uom uom={waterEvent.concreteOnTruck} />
                </td>
              </tr>
            )}
            {reasonText && (
              <tr>
                <td className={cn('header-cell')}>
                  <Localization.Translate stringId="reason" data-testid="reason-label" />
                </td>
                <td className={cn('data-cell')} data-testid={`${testId}-row-${index}-reason-value`}>
                  {translation && translation !== key ? translation : waterEvent?.reason?.description}
                </td>
              </tr>
            )}
          </table>
        );
      })}
    </Styled>
  );
};
